import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  calculatedViewMode,
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { getSystemData } from '../../../System/reducer';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../../components/fields/TextInput/TextInput';
import { POPUP_LIST_NAME } from '../../../../configs';
import { addGlobalPopUpWrapper } from '../../../InformationScreenWrapper/actions';
import getDefaultSort from '../../../../utils/getDefaultSort';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';
import { getRegisterData } from '../../../RegionRegistry/reducer';
import { loadSZLTList } from '../../../RegionRegistry/actions';
import { REGION_REGISTRY_MODULE } from '../../../../configs/moduleNames';
import { szltColumns } from '../../../RegionRegistry/components/szltColumns';
import TextSearchInput from '../../../../components/fields/TextInput/TextSearchInput';

export function OrderServiceBox(props) {
  const { onClose = () => {} } = props;
  const dispatch = useDispatch();
  const {
    loadingSzltList,
    szltList = [],
    szltListMeta,
  } = useSelector(getRegisterData);
  const store = useStore();
  const {
    formatMessage,
  } = intlShape;
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };
  const loadData = opts => {
    const filterData = getValues();
    const viewModeData = calculatedViewMode(filterData.view_mode);
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].orderServiceListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { ...filterData, ...viewModeData },
      sort,
    };
    const p1 = dispatch(loadSZLTList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData('driver-services-filter', {}) });
  const { updatePeriod } = useSelector(getSystemData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  const [sort, setSort] = useState(getDefaultSort());

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem('driver-services-filter', JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  return (
    <div className="dlc-body flex-column">
      <TimerLoader loading={loadingSzltList} />
      <div className="dlc-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'driver.card.menu.service' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
          />
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={szltList}
            columns={szltColumns}
            onDoubleClickByRow={item => {
              dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.ORDER_SERVICE_DETAIL, id: item.id })));
            }}
            additionalColumns={[]}
            name="driver-order-service-list"
            changeSort={changeSort}
            sort={sort}
            settingsFormatter={moreFormatter}
            rowClassFormatter={rowClassFormatter}
          />
        </div>
        <Pagination meta={szltListMeta} list={szltList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
